import {
    ApartmentOutlined,
    AppstoreAddOutlined,
    AppstoreOutlined,
    BranchesOutlined,
    BuildOutlined,
    CalendarOutlined,
    CheckCircleOutlined,
    CheckSquareOutlined,
    ClockCircleOutlined,
    ClusterOutlined,
    ContactsOutlined,
    CreditCardOutlined,
    CrownOutlined,
    DeleteOutlined,
    DollarCircleOutlined,
    ExclamationCircleOutlined,
    FileExcelOutlined,
    ForkOutlined,
    FormOutlined,
    InfoCircleOutlined,
    LeftOutlined,
    LinkOutlined,
    PieChartOutlined,
    SaveOutlined,
    ScheduleOutlined,
    SettingOutlined,
    SmileOutlined,
    TeamOutlined,
    ThunderboltOutlined,
    UserOutlined,
    UserSwitchOutlined,
    WarningOutlined,
    BellOutlined,
} from '@ant-design/icons';
import { BiTaskX } from "react-icons/bi";
import {
    BsTable
} from 'react-icons/bs';
import { FaTriangleExclamation } from "react-icons/fa6";
import {
    FiExternalLink
} from 'react-icons/fi';
import {
    IoIosWarning
} from "react-icons/io";
import { LiaClone } from "react-icons/lia";

const icons = {
    Dashboard: <AppstoreOutlined />,
    General: <AppstoreOutlined />,
    Competition: <ApartmentOutlined />,
    Sponsor: <DollarCircleOutlined />,
    Season: <CalendarOutlined />,
    Group: <ClusterOutlined />,
    Phase: <BranchesOutlined />,
    Venue: <BuildOutlined />,
    Award: <CrownOutlined />,
    Team: <TeamOutlined />,
    Player: <UserOutlined />,
    Person: <SmileOutlined />,
    Event: <ScheduleOutlined />,
    Game: <ThunderboltOutlined />,
    Run: <ThunderboltOutlined />,
    Disciplinary: <BiTaskX />,
    Save: <SaveOutlined />,
    Settings: <SettingOutlined />,
    Error: <ExclamationCircleOutlined />,
    ErrorTriangle: <FaTriangleExclamation />,
    ErrorTriangleOutlined: <WarningOutlined />,
    Back: <LeftOutlined />,
    ExternalLink: <FiExternalLink />,
    Trash: <DeleteOutlined />,
    Create: <AppstoreAddOutlined />,
    Link: <LinkOutlined />,
    Export: <FileExcelOutlined />,
    Statistics: <BsTable size="12" />,
    WarningTriangle: <IoIosWarning />,
    SeasonRegistration: <FormOutlined />,
    SeasonRegistrationRequest: <CheckSquareOutlined />,
    Information: <InfoCircleOutlined />,
    Correct: <CheckCircleOutlined />,
    Pending: <ClockCircleOutlined />,
    Scheduler: <ForkOutlined />,
    Infographics: <PieChartOutlined />,
    Clone: <LiaClone className="w-[1.3em] h-[1.3em]" />,
    Contacts: <ContactsOutlined />,
    CreditCard: <CreditCardOutlined />,
    TeamManager: <UserSwitchOutlined />,
    Notification: <BellOutlined />, 
};

export default icons;
